// Počet u položky menu „K vyřízení (n)“ (05/18, W24): součet otevřených položek ve všech záložkách, které účet vidí
// (`GET /k-vyrizeni?jen_pocty=true`, api/k-vyrizeni.ts). Nula se neukazuje; v popisku je rozpis po záložkách.
import { SEKCE_K_VYRIZENI, usePoctyKVyrizeni } from '../api/k-vyrizeni';
import { usePrihlaseni } from '../prihlaseni/stav-prihlaseni';
import './Shell.css';

export function PocetKVyrizeni({ testId = 'pocet-k-vyrizeni' }: { testId?: string } = {}) {
  const { ja } = usePrihlaseni();
  const povoleno = Boolean(ja && (ja.sekce ?? []).includes(SEKCE_K_VYRIZENI));
  const pocty = usePoctyKVyrizeni(povoleno);
  if (!povoleno || !pocty.nacteno || pocty.celkem === 0) return null;
  return (
    <span
      className="lista__pocet"
      data-testid={testId}
      aria-label={`${pocty.celkem} položek k vyřízení`}
      title={pocty.zalozky.map((z) => `${z.nazev}: ${z.pocet}`).join(' · ')}
    >
      {pocty.celkem}
    </span>
  );
}
